import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	get(): boolean {
		return fg('relay-migration-issue-header-and-parent');
	},
};
